/**
 * Simple memoization utility which wraps a unary function,
 * and returns the last output if called with the last input (strict equality).
 *
 * @param { (input: Y) => R } fn
 * Function invoked when input changes.
 *
 * @returns { typeof fn }
 * The memoized function.
 */

export function strictMemo<Y, R>(fn: (input: Y) => R): typeof fn {
  let memento: [Y, R] | null = null;
  return function memoized(input: Y): R {
    if (memento !== null && memento[0] === input) return memento[1];
    const output = fn(input);
    memento = [input, output];
    return output;
  };
}
